/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { AccountEmailOtpStartResponse, AccountEmailOtpStartVars } from '../openapi-types.gen.js';

export type { AccountEmailOtpStartResponse, AccountEmailOtpStartVars } from '../openapi-types.gen.js';

export const useAccountEmailOtpStart = createMutationHook<AccountEmailOtpStartVars, AccountEmailOtpStartResponse, unknown>({
  specName: 'useAccountEmailOtpStart',
  path: '/v1/me/email/otp/start',
  method: 'POST',
  resolveUrl: (vars: AccountEmailOtpStartVars) => `/v1/me/email/otp/start`,
  buildBody: (vars: AccountEmailOtpStartVars) => ({ email: vars.email }),
  parseResponse: (raw: unknown): AccountEmailOtpStartResponse => raw as AccountEmailOtpStartResponse,
  
  
  
});
